import React from 'react';
import { PrimaryButton } from 'ui/button';
import { FormField } from 'ui/formField';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/modal';
import { Select } from 'ui/selectv2/Select';
import { isBoss } from 'utils/userContext';
import { THEME_OPTIONS } from './constants';
import { MockSettings } from './MockSettings';
import { StyledCoreDateRangePickerRelative } from '../Dashboard.styled';

// type Props = {
//   /** The default relative end range of the dashboard. */
//   defaultEndRange: string,
//   /** The default relative start range of the dashboard. */
//   defaultStartRange: string,
//   /** Callback when the theme changes. */
//   onChangeTheme: (string) => {},
//   /** Callback function when setting modal closes. */
//   onClose: () => {},
//   /** Callback function when settings are saved. */
//   onSave: () => {},
//   /** Callback function when dashboard changes. */
//   onSetDashboard: ([]) => {},
//   /** Determines if the settings modal is open. */
//   open: boolean,
//   /** The theme of the dashboard. */
//   theme: string,
//   /** User context object. */
//   userContext: {},
// };

export default class SettingsModal extends React.Component {
  static defaultProps = {
    onChangeTheme: () => {},
    onClose: () => {},
    onSave: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      defaultEndRange: undefined,
      defaultStartRange: undefined,
    };
  }

  shouldComponentUpdate = (nextProps) => {
    const { defaultEndRange, defaultStartRange, open } = nextProps;
    if (open && open !== this.props.open && !this.state.defaultStartRange) {
      this.setState({ defaultEndRange, defaultStartRange });
      return false;
    }
    return true;
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleChangeDefaultEndRange = (defaultEndRange) => {
    this.setState({ defaultEndRange });
  };

  handleChangeDefaultStartRange = (defaultStartRange) => {
    this.setState({ defaultStartRange });
  };

  handleChangeTheme = ({ value }) => {
    this.props.onChangeTheme(value);
  };

  handleSubmit = () => {
    const { onClose, onSave, theme } = this.props;
    const { defaultStartRange, defaultEndRange } = this.state;
    const updatedSettings = {
      theme,
      defaultStartRange,
      defaultEndRange,
    };
    onSave(updatedSettings);
    onClose(updatedSettings);
  };

  render() {
    const { onSetDashboard, open, theme, userContext } = this.props;
    const { defaultStartRange, defaultEndRange } = this.state;
    const themeDropdownValue =
      THEME_OPTIONS.find((option) => option.value === theme) || THEME_OPTIONS[0];

    return open ? (
      <Modal id="dashboardSettingsModal" isModalOpen={open} onClose={this.handleClose}>
        <ModalHeader>Dashboard Settings</ModalHeader>
        <ModalBody>
          <FormField labelText="Theme">
            <Select
              usePortal
              options={THEME_OPTIONS}
              value={[themeDropdownValue]}
              onChange={this.handleChangeTheme}
            />
          </FormField>
          <FormField labelText="Default Date Range">
            <StyledCoreDateRangePickerRelative
              endRange={defaultEndRange}
              onEndRangeChange={this.handleChangeDefaultEndRange}
              onStartRangeChange={this.handleChangeDefaultStartRange}
              showTo={false}
              startRange={defaultStartRange}
            />
          </FormField>
          {isBoss(userContext) && (
            <FormField labelText="Dashboard Mock">
              <MockSettings onSetDashboard={onSetDashboard} />
            </FormField>
          )}
        </ModalBody>
        <ModalFooter onCancel={this.handleCLose}>
          <PrimaryButton onClick={this.handleSubmit}>Save</PrimaryButton>
        </ModalFooter>
      </Modal>
    ) : null;
  }
}
